import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AnalyticsEventDirectiveModule } from 'idt-analytics-api/directives/analytics-events-directive.module';
import { IdtComponentsRenderModule } from 'shared/idt-components/idt-components-render.module';
import { FRAGMENT_SERVICE_TOKEN } from 'shared/services/fragment-shared.service';
import { SharedModule } from 'shared/shared.module';

import { RenderBlocksModule } from './render-blocks/render-blocks.module';
import { RenderPageNotFoundComponent } from './render-page-not-found/render-page-not-found.component';
import { RenderPageComponent } from './render-page.component';
import { RenderStorageModule } from './render-storage/render-storage.module';
import { RenderFragmentService } from './services/render-fragment-service';
import { RenderPageService } from './services/render-page.service';
import { RenderStateService } from './services/render-state/render-state.service';
import { TenantVariablesService } from './services/tenant-variables/tenant-variables.service';
import { RenderSvgSpriteComponent } from './svg-sprite/svg-sprite.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RenderBlocksModule,
    RenderStorageModule,
    IdtComponentsRenderModule,
    AnalyticsEventDirectiveModule
  ],
  exports: [
    RenderPageComponent,
    RenderSvgSpriteComponent
  ],
  declarations: [
    RenderPageComponent,
    RenderPageNotFoundComponent,
    RenderSvgSpriteComponent
  ],
  providers: [
    RenderPageService,
    RenderStateService,
    TenantVariablesService,
    {
      provide: FRAGMENT_SERVICE_TOKEN,
      useClass: RenderFragmentService
    },
    {
      provide: 'Window',
      useValue: window
    }
  ]
})
export class RenderPageModule {}
